import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import GroundPrepAPI from "../api/GroundPrep.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { GroundPrep, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<GroundPrep>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(groundPrep: GroundPrep): JSX.Element[] {
  return [
    <TableCell key={"name"}>{groundPrep.name}</TableCell>,
    <TableCell key={"createdAt"}>
      {extractDate(groundPrep.createdAt)}
    </TableCell>,
  ];
}

export default function GroundPrepList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Ground Prepping</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={GroundPrepAPI.useList}
          modelBaseUrl={"ground_preps"}
          columns={columns}
          buildTableRow={buildTableRow}
        />

        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={GroundPrepAPI.useSave}
          navigateUrl="/ground_preps"
        />
      </Box>
    </Layout>
  );
}
